// extracted by mini-css-extract-plugin
export default {"ScrollBar":"bookingIndexPage_ScrollBar__1or0Y"};